export default __webpack_public_path__ + "static/batiments2b_pruned.webp-6b9fa4696e6a2a599e941381127d01c7.png";